module.exports = __webpack_public_path__ + "Deepanshusingh-929c236f.webp";